import React from "react";
import PoseModelWarmup from "./pose/PoseModelWarmup";
import VoiceModelWarmup from "./live/VoiceModelWarmup";

/** The models the app fetches in the background from whichever screen opens first: the pose model (for uploads) and
 * the coaching voice (for free clips' read-out coaching, owner 2026-10-20). Renders nothing visible. */
export default function BackgroundWarmups() {
  return (
    <>
      <PoseModelWarmup />
      <VoiceModelWarmup />
    </>
  );
}
